export enum NatureOfDataEnum {
  patrimoine = 'patrimoine',
  composant = 'composant'
}
